<form class="form" [formGroup]="formGroup">
    <app-common-dropdown [service]="currentPriceService" [label]="'Работа'" [formCtrl]="pricesControl" data-testid="price-selector-dropdown"/>
    <div class="equipment-wrapper">
        @if (pricesControl.value) {
            <app-common-dropdown [service]="currentEquipmentService" [label]="'Оборудование'" [formCtrl]="itemControl" data-testid="item-selector-dropdown"/>
        }
        <button mat-stroked-button type="button" class="add-button" (click)="toggleAddItemForm()">Добавить</button>
    </div>
    @if (showAddItemForm) {
        <div class="add-form">
            <mat-form-field appearance="fill" class="add-item-input">
                <mat-label>Название оборудования</mat-label>
                <input matInput [formControl]="newItemNameControl"/>
            </mat-form-field>
            <button mat-flat-button color="primary" type="button" (click)="saveNewItem()" [disabled]="savingNewItem">Сохранить</button>
            <button mat-stroked-button type="button" (click)="cancelAddItem()" [disabled]="savingNewItem">Отмена</button>
        </div>
    }
    <mat-form-field appearance="fill">
        <mat-label>Количество</mat-label>
        <input matInput type="number" formControlName="quantity" [min]="1"/>
    </mat-form-field>
    @if (canEditOrderPrice) {
        <mat-form-field appearance="fill">
            <mat-label>Цена в заявке</mat-label>
            <input matInput type="number" formControlName="priceValue" [min]="0" step="0.01" (input)="syncCustomPrice()"/>
        </mat-form-field>
    }
    <small>Стоимость: {{calculateTotalPrice()}}</small>
</form>
